export default class BanyanTag {
  OLD_AFTER = 86400; // seconds (1 day)
  EXPIRES_AFTER = 31536000; // seconds (365 days)
  touch() {
    window.bbTagsUpdatedAt = '' + Date.now() / 1000; // in seconds
    if (this.supportsLocalStorage()) {
      window.localStorage.setItem('tags_updated_at', window.bbTagsUpdatedAt);
    }
  }

  validateTag(tag) {
    if (tag.includes('.')) {
      throw 'period is not allowed in tag';
    }
    let tags = window.bbTags;
    if (typeof tags !== 'string') {
      throw 'bbTags not initialized or modified incorrectly';
    }
  }

  supportsLocalStorage() {
    return typeof (Storage) !== 'undefined';
  }

  initializePage() {
    if (this.supportsLocalStorage()) {
      window.bbTagsCreatedAt = window.localStorage.getItem('tags_created_at');
      window.bbTagsUpdatedAt = window.localStorage.getItem('tags_updated_at');
      window.bbTags = window.localStorage.getItem('tags');
      window.bbHasTag = function(tag) {
        return window.bbTags.indexOf('.' + tag + '.') !== -1;
      };
      window.bbMissingTag = function(tag) {
        return window.bbTags.indexOf('.' + tag + '.') === -1;
      };
    }

    try {
      // check if user tagging has been initialized
      let createdAt = this.getCreatedAt();
      let updatedAt = this.getUpdatedAt();
      let currentTimestamp = Date.now() / 1000;
      let timeElapsedSinceLastActivity = currentTimestamp - updatedAt;

      if (!createdAt || timeElapsedSinceLastActivity > this.EXPIRES_AFTER) {
        // initialize tagging
        this.create();
      } else {
        // tagging already initialized, check if user is no longer 'new'
        if (currentTimestamp - createdAt > this.OLD_AFTER) {
          this.removeTag('new');
        }
      }
    } catch (error) {
      // fail silently
    }
  }

  getCreatedAt() {
    return window.bbTagsCreatedAt;
  }

  getUpdatedAt() {
    return window.bbTagsUpdatedAt;
  }

  create() {
    window.bbTags = '.';
    window.bbTagsCreatedAt = '' + Date.now() / 1000; // in seconds
    if (this.supportsLocalStorage()) {
      window.localStorage.removeItem('tags');
      this.addTag('new');
      window.localStorage.setItem('tags_created_at', window.bbTagsCreatedAt);
    }
    this.touch();
    return true;
  }

  addTag(tag) {
    this.validateTag(tag);
    let tags = window.bbTags;
    if (tags.includes('.' + tag + '.')) {
      // tag in tag list, just return
      this.touch();
      return true;
    }
    tags += tag + '.';
    window.bbTags = tags;
    if (this.supportsLocalStorage()) {
      window.localStorage.setItem('tags', tags);
    }
    this.touch();
    return true;
  }

  removeTag(tag) {
    this.validateTag(tag);
    let tags = window.bbTags;
    if (!tags.includes('.' + tag + '.')) {
      // tag not in tag list, just return
      this.touch();
      return true;
    }
    tags = tags.replace('.' + tag + '.', '.');
    window.bbTags = tags;
    if (this.supportsLocalStorage()) {
      window.localStorage.setItem('tags', tags);
    }
    this.touch();
    return true;
  }
}